// extracted by mini-css-extract-plugin
var _1 = "ra-message-btn";
var _2 = "ra-message-centered";
var _3 = "ra-message";
var _4 = "ra-message-border";
export { _1 as "closeBtnCls", _2 as "messageCenterCls", _3 as "messageCls", _4 as "messagedBorderCls" }
